import { render, staticRenderFns } from "./HistoriesPage.vue?vue&type=template&id=04b489c7&scoped=true&"
import script from "./HistoriesPage.vue?vue&type=script&lang=js&"
export * from "./HistoriesPage.vue?vue&type=script&lang=js&"
import style0 from "./HistoriesPage.vue?vue&type=style&index=0&id=04b489c7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b489c7",
  null
  
)

export default component.exports